export const DomainPageLayout = {
    slots: ['Section1B','Section1BVideo', 'SlbDomainContainerSlot', 'SlbBlueBottomBannerSlot'],
};
